/**
 * When a search finds nothing, the searched text can seed a new record: it
 * goes into the first field a person would type into - the first editable
 * text-like field of the form in its display order. Relations, dates,
 * numbers and files are skipped; the search string means nothing to them.
 */
const TEXT_TYPES = new Set(['string', 'text', 'barcode', 'qr_code', 'url', 'markdown']);

interface PrefillableField {
    code: string;
    type: string;
    editable?: boolean;
    context?: string | null;
    sortOrder?: number;
}

export const searchPrefillFieldCode = (fields: PrefillableField[] | undefined): string | null => {
    const candidate = [...(fields ?? [])]
        .filter(f => !f.context && f.editable !== false && TEXT_TYPES.has(f.type))
        .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))[0];

    return candidate?.code ?? null;
};

/** The prefill for a form, or null when the form has no field that can take the text. */
export const searchPrefill = (fields: PrefillableField[] | undefined, search: string): Record<string, string> | null => {
    const code = searchPrefillFieldCode(fields);
    const text = search.trim();
    if (!code || text === '') {
        return null;
    }

    return {[code]: text};
};
